module.exports = __webpack_public_path__ + "img/coalGas.b305cd9f.png";